import { CosignaturePermissionMetadata } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";
import { Hint } from "@/ui2/atoms/Hint";

type EnabledByLabelProps = {
  requirementReason: CosignaturePermissionMetadata["requirement_reason"];
  requirementReasonDetails?: CosignaturePermissionMetadata["requirement_reason_details"];
  stateUpdatedAt: CosignaturePermissionMetadata["state_updated_at"];
  stateUpdatedByName: CosignaturePermissionMetadata["state_updated_by_name"];
};

export function EnabledByLabel({
  requirementReason,
  requirementReasonDetails,
  stateUpdatedAt,
  stateUpdatedByName,
}: EnabledByLabelProps) {
  const formattedDate = dayjs(stateUpdatedAt).format("MM/DD/YYYY");

  const isOtherReason = requirementReason === "Other";
  const displayReason =
    isOtherReason && requirementReasonDetails ? requirementReasonDetails : requirementReason;

  return (
    <Hint>
      Enabled by {stateUpdatedByName} {formattedDate}. Reason: {displayReason}
    </Hint>
  );
}
